import { motion } from 'framer-motion';
import { User, Heart, Users, ShieldCheck } from 'lucide-react';

const audiences = [
  {
    icon: User,
    title: 'Connect One',
    subtitle: 'For individuals',
    description: 'Wellness + optional sharing.',
  },
  {
    icon: Heart,
    title: 'Connect Duo',
    subtitle: 'For couples',
    description: 'Shared wellness, routines, peace of mind.',
  },
  {
    icon: Users,
    title: 'Connect Family',
    subtitle: 'For families',
    description: 'One private dashboard for everyone.',
  },
  {
    icon: ShieldCheck,
    title: 'Connect Care',
    subtitle: 'For care needs',
    description: 'Safety monitoring for seniors & kids.',
  },
];

const WhoItsFor = () => {
  return (
    <section className="section" data-testid="who-its-for-section">
      <div className="container-custom">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-10 md:mb-14"
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold text-[#1A1A1A] mb-3">
            Designed for Everyone.
          </h2>
          <p className="text-[#5A5A5A] text-base md:text-lg">
            Choose the Connect that fits your life.
          </p>
        </motion.div>

        {/* Cards */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {audiences.map((item, index) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="wellness-card text-center group"
              data-testid={`audience-card-${item.title.toLowerCase().replace(' ', '-')}`}
            >
              <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-black/5 
                              flex items-center justify-center group-hover:bg-black/8 transition-colors">
                <item.icon className="w-5 h-5 text-[#4A4A4A]" />
              </div>
              <h3 className="text-base font-semibold text-[#1A1A1A] mb-1">
                {item.title}
              </h3>
              <p className="text-xs text-[#7A7A7A] mb-2">{item.subtitle}</p>
              <p className="text-[#5A5A5A] text-sm">
                {item.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoItsFor;
